import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { mapFamilyApiError } from '~entities/family/lib/map-family-api-error';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const ensureFamily = async (args: {
  parentId: string;
  displayName?: string;
}) => {
  const response = await baseAPI.post('/v2/families/ensure', args);
  return response.data as { family: { _id: string }; created: boolean };
};

export const useEnsureFamily = (studentId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ensureFamily,
    onSuccess: () => {
      toast.success('Family created');
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_BY_STUDENT],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_HUB],
      });
    },
    onError: (error: unknown) => {
      toast.error(mapFamilyApiError(error, 'Failed to create family'));
    },
  });
};
